export default __webpack_public_path__ + "static/media/new-time-icon.5739fc4f.svg";